module.exports = __webpack_public_path__ + "static/img/shijihaocai.33d4e758.jpg";